import { render, staticRenderFns } from "./CompanyMonitor.vue?vue&type=template&id=6336f37c&scoped=true"
import script from "./CompanyMonitor.vue?vue&type=script&lang=ts"
export * from "./CompanyMonitor.vue?vue&type=script&lang=ts"
import style0 from "./CompanyMonitor.vue?vue&type=style&index=0&id=6336f37c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6336f37c",
  null
  
)

export default component.exports